import { Mail, Phone, MapPin } from 'lucide-react';
import { Link } from 'react-router-dom';
import { Separator } from '@/components/ui/separator';

export const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-card border-t border-border/50 relative overflow-hidden">
      {/* Background glow */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[800px] h-[300px] bg-primary/5 blur-[150px] rounded-full" />
      
      <div className="container mx-auto px-4 py-16 relative z-10">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          {/* Company Info */}
          <div>
            <img 
              src="https://customer-assets.emergentagent.com/job_79ae8060-e1f8-4d28-b152-a3397f858fee/artifacts/8r1orql6_syncline%20logistics%20logo.png" 
              alt="Syncline Logistics" 
              className="h-12 w-auto mb-4"
            />
            <p className="text-sm text-muted-foreground mb-4 leading-relaxed">
              Professional courier and LTL delivery services across GTA and Ontario. Fast, reliable, and secure logistics solutions for your business.
            </p>
            <div className="text-sm text-muted-foreground">
              <strong className="text-foreground">Licensed & Insured</strong>
              <br />Serving businesses since 2009
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="font-semibold text-lg mb-4">Quick Links</h3>
            <ul className="space-y-3">
              <li>
                <Link to="/services" className="text-muted-foreground hover:text-primary transition-colors text-sm">
                  Our Services
                </Link>
              </li>
              <li>
                <Link to="/coverage" className="text-muted-foreground hover:text-primary transition-colors text-sm">
                  Coverage Area
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-muted-foreground hover:text-primary transition-colors text-sm">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/track" className="text-muted-foreground hover:text-primary transition-colors text-sm">
                  Track Shipment
                </Link>
              </li>
              <li>
                <Link to="/testimonials" className="text-muted-foreground hover:text-primary transition-colors text-sm">
                  Testimonials
                </Link>
              </li>
              <li>
                <Link to="/quote" className="text-muted-foreground hover:text-primary transition-colors text-sm">
                  Get a Quote
                </Link>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h3 className="font-semibold text-lg mb-4">Services</h3>
            <ul className="space-y-3 text-sm text-muted-foreground">
              <li>LTL Shipments</li>
              <li>Same-Day Courier</li>
              <li>Scheduled Delivery</li>
              <li>Freight Transport</li>
              <li>Express Services</li>
              <li>Real-Time Tracking</li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="font-semibold text-lg mb-4">Contact Us</h3>
            <ul className="space-y-4">
              <li>
                <a href="tel:(647)-642-0062" className="flex items-start gap-3 text-muted-foreground hover:text-primary transition-colors group">
                  <Phone className="h-5 w-5 mt-0.5 flex-shrink-0 group-hover:text-primary" />
                  <div className="text-sm">
                    <div className="font-medium text-foreground">Phone</div>
                    <div>(647)-642-0062</div>
                    <div className="text-xs text-primary">24/7 Support</div>
                  </div>
                </a>
              </li>
              <li>
                <a href="mailto:info@synclinelogistics.com" className="flex items-start gap-3 text-muted-foreground hover:text-primary transition-colors group">
                  <Mail className="h-5 w-5 mt-0.5 flex-shrink-0 group-hover:text-primary" />
                  <div className="text-sm">
                    <div className="font-medium text-foreground">Email</div>
                    <div>info@synclinelogistics.com</div>
                  </div>
                </a>
              </li>
              <li>
                <div className="flex items-start gap-3 text-muted-foreground">
                  <MapPin className="h-5 w-5 mt-0.5 flex-shrink-0" />
                  <div className="text-sm">
                    <div className="font-medium text-foreground">Service Area</div>
                    <div>Greater Toronto Area</div>
                    <div>& Ontario</div>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>

        <Separator className="mb-8" />

        {/* Bottom section */}
        <div className="flex flex-col md:flex-row justify-between items-center gap-4 text-sm text-muted-foreground">
          <div>
            © {currentYear} <span className="text-foreground font-semibold">Syncline Logistics</span>. All rights reserved.
          </div>
          <div className="flex items-center gap-6">
            <button className="hover:text-primary transition-colors">Privacy Policy</button>
            <button className="hover:text-primary transition-colors">Terms of Service</button>
            <button className="hover:text-primary transition-colors">Careers</button>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
